'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserSavedReport } from '../../Entities/User/UserSavedReport';
import { UserSavedReportCollection } from '../../Collections/User/UserSavedReportCollection';

export class UserSavedReportRepository extends CoreRepository {
  public getUserSavedReports(userId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserSavedReports(userId, options).then((response) => {
      const collection = new UserSavedReportCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserSavedReport();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public createUserSavedReport(userId: number, payload: object = {}) {
    return this.webAPI.createUserSavedReport(userId, payload).then((response) => {
      const userSavedReport = new UserSavedReport();
      userSavedReport.hydrate(response);

      return userSavedReport;
    });
  }

  public removeUserSavedReport(userId: number, savedReportId: number) {
    return this.webAPI.removeUserSavedReport(userId, savedReportId).then((response) => {
      return response;
    });
  }

  /*
    public getUserSavedReport(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getUserSavedReport(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let UserSavedReport = new UserSavedReport();
            UserSavedReport.hydrate(response);

            return UserSavedReport;
        });
    }

    

    public updateUserSavedReport(payload: object = {}){  
        return this.webAPI.updateUserSavedReport(payload)
        .then( response => {
            let UserSavedReport = new UserSavedReport();
            UserSavedReport.hydrate(response);

            return UserSavedReport;
        });
    }

   
    */
}
